import src from "IMAGE";
export default { src, width: 102, height: 12, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIUlEQVR42mOQC+RvlfHjqwdhWT/+BhAGsX0sROtblORaAX/2CD7vPnVCAAAAAElFTkSuQmCC"};
